import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=5562c05e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anteater\\Desktop\\projects\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5562c05e"]])

export default __exports__